import { render, staticRenderFns } from "./CarbonCredits.vue?vue&type=template&id=60e2eb06"
import script from "./CarbonCredits.vue?vue&type=script&lang=js"
export * from "./CarbonCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports